import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";
import { useParams } from "react-router-dom";

const BlogSection = () => {
  const { id } = useParams();
  const [blogs, setBlogs] = useState([]);
  const fetchBlogData = async () => {
    try {
      const response = await corefetch(`Blog/GetBlogsCategorieswise?Id=${id}`);
      if (response && response.length > 0) {
        setBlogs(response);
      } else {
        setBlogs([]);
        console.error("No blog data found");
      }
    } catch (error) {
      setBlogs([]);
      console.error("Failed to fetch blog data", error);
    }
  };
  useEffect(() => {
    fetchBlogData();
  }, [id]);

  if (!blogs || blogs.length == 0) {
    return null;
  }

  function truncateHtml(html, maxLength) {
    const div = document.createElement("div");
    div.innerHTML = html;

    let text = div.textContent || div.innerText || "";
    if (text.length > maxLength) {
      text = text.slice(0, maxLength) + "...";
    }

    return text;
  }

  return (
    <>
      {blogs.map((blog, index) => {
        const eventDate = new Date(blog.eventDate);
        const day = eventDate.getDate();
        const month = eventDate.toLocaleString("default", { month: "short" });
        const year = eventDate.getFullYear();

        return (
          <div className="col-12 col-lg-4 order-lg-2 mb-4" key={index}>
            <div className="wpo-blog-content">
              <div className="post format-standard-image">
                <div className="wpo-blog-section blog-section">
                  <div className="wpo-blog-items">
                    <div
                      className="wpo-blog-grids gallery-container clearfix"
                      style={{ display: "block" }}
                    >
                      {/* Ensures one image per row */}
                      <div className="grid" style={{ width: "100%" }}>
                        <div
                          className="wpo-blog-item"
                          style={{ width: "100%" }}
                        >
                          <div
                            className="wpo-blog-img blog-img"
                            style={{
                              height: "300px",
                              width: "100%",
                              overflow: "hidden",
                            }}
                          >
                            <a href={`/blogdetail/${blog.blogsID}`}>
                              <img
                                src={`${ImageURL}${blog.thumbImagePath}`}
                                alt={blog.title}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  objectPosition: "top",
                                }}
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Blog Details */}
                <div className="entry-meta">
                  <ul>
                    <li>
                      <i className="fi flaticon-calendar-1" />
                      <a href="#">{`${month} ${day} ${year}`}</a>
                    </li>
                  </ul>
                </div>
                <div className="entry-details">
                  <h3>
                    <a href={`/blogdetail/${blog.blogsID}`}>{blog.title}</a>
                  </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: truncateHtml(blog.description, 200),
                    }}
                  />
                  <a href={`/blogdetail/${blog.blogsID}`} className="read-more">
                    READ MORE...
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default BlogSection;
